// src/components/CoinIcon.tsx
import React, { FC, useEffect, useState } from 'react';

interface BankIconProps {
    symbol: string;
    className?: string;
}

const loadIcon = async (symbol: string) => {
    try {
        const icon = await import(`../../assets/banks/${symbol}.svg`);
        return icon.default; // Assuming the SVG is exported as default
    } catch (error) {
        console.log(error);
        return error;
    }
};

const _BankIcon: FC<BankIconProps> = (props) => {
    const [iconPath, setIconPath] = useState<string | null>(null);

    useEffect(() => {
        const fetchIcon = async () => {
            const path = await loadIcon(props.symbol);
            setIconPath(path);
        };

        fetchIcon();
    }, [props.symbol]);

    return <img className={`${props.className}`} src={iconPath || ''} alt={props.symbol} />;
};

export default _BankIcon;
